import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { getHubRoute, HUB_TYPES } from '../utils/hubRoutes';
import ForceReauth from './ForceReauth';

const AppRedirect = () => {
    const { currentUser, userClaims, organization, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!currentUser) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!userClaims?.orgId) {
        return <Navigate to="/hubs" replace />;
    }

    if (!organization?.id) {
        return <ForceReauth />;
    }

    if (organization.organization_type !== HUB_TYPES.PROJECT_MANAGEMENT) {
        return <Navigate to={getHubRoute(organization)} replace />;
    }

    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const orgId = userClaims.orgId;

    if (pathSegments.length > 1 && pathSegments[0] === 'app') {
        const pathAfterApp = pathSegments.slice(1).join('/');
        const secondSegment = pathSegments[1];
        if (secondSegment && !isNaN(parseInt(secondSegment, 10))) {
            return null;
        }

        const redirectPath = `/app/${orgId}/${pathAfterApp}${location.search}${location.hash}`;
        return <Navigate to={redirectPath} replace />;
    }

    return <Navigate to={`/app/${orgId}${location.search}${location.hash}`} replace />;
};

export default AppRedirect;
